import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { fetchSampleInfo } from '../components/api';
// import TopAbundanceFromRank from '../utils/topAbundanecFromRank';
import Loading from '../components/loading';
import SunburstPlot from '../components/widgets/SunburstPlot';
import GraphPlot from '../components/widgets/GraphPlot';
import buildTaxonomicTree from '../utils/makeNestedStructure';
// import { hierarchy } from 'd3';
import * as d3 from 'd3';

function SingleSample() {

    const divCenteredeInfoStyle = {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        // justifyContent: 'center',
        // alignItems: 'center',
        flexDirection: 'column',
        height: '100vh',
        // margin: top right bottom left
        margin: '50px 60px 20px 60px',
        padding: '20px',
        overflowX: 'hidden',
        overflowY: 'auto',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        borderRadius: '10px',
    };

    // divInner should start in the top left corner of the parent div
    const divInner = {
        // padding: '40px',
        padding: '0px 40px',
    }

    const h1Style = {
        color: 'white',
        fontSize: '30px'
    }

    const h2Style = {
        color: 'white',
        fontSize: '25px',
        margin: '0px'
    }

    const pStyle = {
        color: 'white',
        fontSize: '20px',
        margin: '0px'
    }

    const [sampleMetaData, setSampleMetaData] = useState(null);
    const [sampleTaxaData, setSampleTaxaData] = useState(null);
    // const [kronaData, setKronaData] = useState(null);
    const [taxonomyTreeData, setTaxonomyTreeData] = useState(null);
    // const [minRank, setMinRank] = useState('g');
    // const [maxRank, setMaxRank] = useState('p');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const location = useLocation();
    const sample = location.state?.selectedSample || [];

    const fetchSampleData = async (sample) => {
        const sampleId = sample.flat()[0];
        console.log(sampleId)
        try {
            const sampleData = await fetchSampleInfo(sampleId)
            // console.log(sampleData)
            setSampleMetaData(sampleData.meta_data)
            setSampleTaxaData(sampleData.taxonomic_data)

            setLoading(false)
        } catch (err) {
            setError('failed to fetch sample data');
        }
    }


    useEffect(() => {
        fetchSampleData(sample);
    }, [sample]);

    useEffect(() => {
        if (sampleTaxaData) {
            // convert to d3 hierarchy 
            // console.log(sampleMetaData)
            // console.log(sampleTaxaData)
            // setKronaData(d3.hierarchy(buildTaxonomicTree(sampleTaxaData)))
            // setTaxonomyTreeData(d3.hierarchy(buildTaxonomicTree(sampleTaxaData)))
            setTaxonomyTreeData(d3.hierarchy(buildTaxonomicTree(sampleTaxaData)).data)
            // console.log(buildTaxonomicTree(sampleTaxaData))
            console.log(d3.hierarchy(buildTaxonomicTree(sampleTaxaData)).data)

        }
    }, [sampleTaxaData]);

    if (loading || !sampleMetaData) {
        return <Loading />;
    }
    if (error) {
        return <div>{error}</div>;
    }
    // const sampleId = sample.flat()[0];

    console.log(sampleMetaData);

    const arr = [
        <br />, `Collection date: ${sampleMetaData.collection_date || 'N/A'}`,
        <br />, `Biome: ${sampleMetaData.source_biome || 'N/A'}`,
        <br />, `Environment material: ${sampleMetaData.environment_material || 'N/A'}`,
        <br />, `Geographic location: ${sampleMetaData.geographic_location || 'N/A'}`,
        <br />, `host sex: ${sampleMetaData.host_sex || 'N/A'}`,
        <br />, `Instrument model: ${sampleMetaData.instrument_model || 'N/A'}`,
        <br />, `pH: ${sampleMetaData.ph || 'N/A'}`,
        <br />, `Environment material: ${sampleMetaData.environment_material || 'N/A'}`,
        <br />, `Salinity: ${sampleMetaData.salinity || 'N/A'}`,
        <br />, `Species: ${sampleMetaData.species || 'N/A'}`,
        <br />, `Temperature: ${sampleMetaData.temperature || 'N/A'}`,
    ]

    return (
        <div style={divCenteredeInfoStyle}>
            {/* <div style={divInner}> */}
            <h1 style={h1Style}> Sample information</h1>
            <p style={pStyle}>Sample ID: {sample.flat()[0]}</p>
            {/* <p>show broad information</p> */}
            <SunburstPlot taxaData={taxonomyTreeData} />
            {/* <GraphPlot taxonomyTree={taxonomyTreeData} minRank={minRank} maxRank={maxRank} /> */}
            <h2 style={h2Style}> Sample metadata</h2>
            <p style={pStyle}>{arr}</p>
            {/* <p>Sample name: {sampleMetaData.sample_name}</p> */}
            {/* <p>Sample description: {sampleMetaData.sample_description}</p> */}
            <Link to="/">Back to Home</Link>
            {/* </div> */}
        </div>
    )
};

export default SingleSample;